import { UploadObjectType } from 'app/types/enums/uploadObjectType';
import type { TUploaderAdapter } from '../types/TUploadParams';
import type { TCall } from 'app/queries/types/TCall';
import { fetchUploadParams, putToS3 } from './S3SignedUrlUploader';

export const RepositoryS3Uploader = (call: TCall, getRepositoryId: () => string): TUploaderAdapter => ({
  requestParams: async ({ file, meta }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    const repositoryId = getRepositoryId();
    if (!repositoryId) {
      throw new Error('Wrong repository ID');
    }
    return fetchUploadParams(meta.name, repositoryId, UploadObjectType.REPOSITORY, call);
  },
  performUpload: async ({ file, params, onProgress, signal }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    return putToS3({ file, params, onProgress, signal });
  },
});
